import { render, staticRenderFns } from "./PriorityBadge.vue?vue&type=template&id=137f1734&scoped=true"
import script from "./PriorityBadge.vue?vue&type=script&lang=js"
export * from "./PriorityBadge.vue?vue&type=script&lang=js"
import style0 from "./PriorityBadge.vue?vue&type=style&index=0&id=137f1734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f1734",
  null
  
)

export default component.exports